
import { Component, Prop, Vue } from 'vue-property-decorator'
import messageNotice from './myMessageNotice.vue'
import myAccountManage from './myAccountManage.vue'
// import myLibrary from './myLibrary.vue'
import myMessageSet from './myMessageSet.vue'
import myTradeRecord from './myTradeRecord.vue'
import myMechanism from './myMechanism.vue'
import i18n from '@/lang/index';

@Component({
  components: {
    myMessageSet,
    myAccountManage,
    myTradeRecord,
    myMechanism,
    messageNotice,
  },
})
export default class MyAllSetting extends Vue {
  private headCenter: string = ''
  private routerDetail: string | any = ''
  mounted() {
    this.routerDetail = this.$route.query.detail
  }
  created() {
    this.headInfo()
  }
  // 处理头部信息
  headInfo() {
    switch (this.routerDetail) {
      case 'myLibrary':
        this.headCenter = i18n.t('ktpMy.文库') as string;
        break
      case 'myTradeRecord':
        this.headCenter = i18n.t('ktpMy.交易记录') as string;
        break
      case 'myMechanism':
        this.headCenter = i18n.t('ktpMy.机构用户认证') as string;
        break
    }
  }
}
